import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import LanguageContext from '../contexts/languageContext';
import useCheckMobileScreen from '../hooks/useWidth';
import PatientFileNav from '../components/PatientFileNav';
import Breadcrumbs from '../components/BreadCrumbs';
import { makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import CustomSideBar from '../components/CustomSideBar';
import MessagesContext from '../contexts/messagesContext';
import useRoutes from './useRoutes';

const styles = makeStyles((theme) => ({
    row: {
        [theme.breakpoints.up(1025)]: {
            display: 'flex'
        }
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minWidth: '82%',
        overflow: ({ isLab }) => isLab && 'hidden'
    }
}));
const RoutesContainer = ({ isSetting = false, children }) => {
    const { lang } = useContext(LanguageContext);
    const { messages } = useContext(MessagesContext);
    const { pathname } = useLocation();
    const isLab = pathname.includes('laboratory');
    const classes = styles({ rtl: lang === 'fa', isLab });
    const isMobile = useCheckMobileScreen();
    const { settingRoutes } = useRoutes();

    return (
        <>
            <div className={classes.row}>
                {!isMobile &&
                    (isSetting ? (
                        <CustomSideBar title={messages.setting} data={settingRoutes} />
                    ) : (
                        <PatientFileNav />
                    ))}
                <div className={classes.column}>
                    {!isMobile && <Breadcrumbs />}
                    <div className={!isMobile && !isSetting && 'container'}>{children}</div>
                </div>
            </div>
        </>
    );
};

RoutesContainer.propTypes = {
    isSetting: PropTypes.bool,
    children: PropTypes.node
};

export default RoutesContainer;
